import { render, staticRenderFns } from "./LgsIndexReq.vue?vue&type=template&id=5a2989ea&"
import script from "./LgsIndexReq.vue?vue&type=script&lang=js&"
export * from "./LgsIndexReq.vue?vue&type=script&lang=js&"
import style0 from "./LgsIndexReq.vue?vue&type=style&index=0&id=5a2989ea&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports